import { XCircleIcon } from '@icons';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
interface MediaitemAccessErrorProps {
  type: 'video' | 'audio' | 'image';
  className?: string;
  errorCode?: number;
}

export enum MediaitemErrorCode {
  MEDIA_ERR_ABORTED = 1,
  MEDIA_ERR_NETWORK = 2,
  MEDIA_ERR_DECODE = 3,
  MEDIA_ERR_SRC_NOT_SUPPORTED = 4
}

const MediaitemAccessError = ({ type, className, errorCode }: MediaitemAccessErrorProps) => {
  const { t } = useTranslation();

  const getErrorMessage = () => {
    switch (errorCode) {
      case MediaitemErrorCode.MEDIA_ERR_ABORTED:
        return t('domains.mediaitems.accessError.aborted.header');
      case MediaitemErrorCode.MEDIA_ERR_NETWORK:
        return t('domains.mediaitems.accessError.network.header');
      case MediaitemErrorCode.MEDIA_ERR_DECODE:
        return t('domains.mediaitems.accessError.decode.header');
      default:
        // this is our default since we assume that we won't allow corrupted or unsupported
        // media files to be uploaded
        return t('domains.mediaitems.accessError.blockingNetwork.header');
    }
  };

  const getHelpMessage = () => {
    switch (errorCode) {
      case MediaitemErrorCode.MEDIA_ERR_ABORTED:
        return t('domains.mediaitems.accessError.aborted.text');
      case MediaitemErrorCode.MEDIA_ERR_NETWORK:
        return t('domains.mediaitems.accessError.network.text');
      case MediaitemErrorCode.MEDIA_ERR_DECODE:
        return t('domains.mediaitems.accessError.decode.text');
      default:
        // this is our default since we assume that we won't allow corrupted or unsupported
        // media files to be uploaded
        return t('domains.mediaitems.accessError.blockingNetwork.text');
    }
  };

  return (
    <div
      className={classNames(
        'flex flex-col items-center justify-center p-lg text-center',
        setupForDark('bg-secondary/50'),
        className
      )}
    >
      <XCircleIcon size={48} className={classNames('mb-md', setupForDark('text-primary'))} />
      <p className={classNames('P4R mb-xs', setupForDark('text-primary'))}>{getErrorMessage()}</p>
      <p className={classNames('P6R', setupForDark('text-primary/70'))}>{getHelpMessage()}</p>
    </div>
  );
};

export default MediaitemAccessError;
